<div class="editable-container">
  <div
    class="editable"
    #editableDivRef
    contenteditable="false"
    (click)="editableClickHandler($event)"
    (keypress)="onKeypress($event)"
    (keydown)="onKeydownHandler($event)"
    (keyup)="onKeyupHandler($event)"
    (blur)="onBlur($event)"
    [attr.data-placeholder]="placeholder"
    [class.error]="error > 0"></div>

  <button *ngIf="showActionButtons" class="bt-cancel" (mousedown)="cancel($event)" title="annuler">
    <span class="icon-view-close" aria-hidden="true"
      ><svg>
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/img/icons.svg#icon-view-close"></use></svg
    ></span>
  </button>
  <button *ngIf="showActionButtons" class="bt-valid" (mousedown)="validate($event)" title="sauvegarder">
    <span class="icon-action-select-thumb" aria-hidden="true"
      ><svg>
        <use
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xlink:href="assets/img/icons.svg#icon-action-select-thumb"></use></svg
    ></span>
  </button>
</div>

<p class="error" *ngIf="error === 1">{{ 'generic.error_invalid_char' | translate }}</p>
<p class="error" *ngIf="error === 2">{{ 'generic.error_min_char' | translate: { minChar: min } }}</p>
<p class="error" *ngIf="error === 3">{{ 'generic.error_max_char' | translate: { maxChar: max } }}</p>
